import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import './app_more_menu.css';

export default function AppMoreMenu({
  items,
  buttonClassName = 'app-more-menu-btn',
  buttonLabel = null,
  buttonIcon = faEllipsis,
  title = 'More',
}) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  return (
    <div className="app-more-menu" ref={menuRef}>
      <button
        type="button"
        className={`${buttonClassName}${buttonLabel ? ' app-more-menu-btn--labeled' : ''}`}
        onClick={() => setOpen((prev) => !prev)}
        title={title}
        aria-label={title}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        {buttonLabel ? (
          <span className="app-more-menu-btn-label">{buttonLabel}</span>
        ) : (
          <FontAwesomeIcon icon={buttonIcon} />
        )}
      </button>
      {open && (
        <div className="app-more-menu-dropdown" role="menu">
          {items.map((item, index) => {
            if (item.type === 'divider') {
              return <div key={`divider-${index}`} className="app-more-menu-divider" role="separator" />;
            }

            return (
              <button
                key={item.label}
                type="button"
                className="app-more-menu-item"
                role="menuitem"
                onClick={() => {
                  setOpen(false);
                  if (item.onClick) {
                    item.onClick();
                  } else if (item.path) {
                    navigate(item.path);
                  }
                }}
              >
                {item.icon && <FontAwesomeIcon icon={item.icon} fixedWidth />}
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
